import { render, staticRenderFns } from "./ReleaseNotesAndManuals.vue?vue&type=template&id=00bd192e"
import script from "./ReleaseNotesAndManuals.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesAndManuals.vue?vue&type=script&lang=js"
import style0 from "./ReleaseNotesAndManuals.vue?vue&type=style&index=0&id=00bd192e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports